import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IUserFeatureState } from './user.states';
import { initUser, setUserInfo, setUserIsInitMerchant } from './user.actions';
import { EMPTY, map, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { selectUser } from './user.selectors';
import { authenticatedProfileReady, updateToken } from '../auth/auth.action';
import { UserService } from 'src/app/services/user.service';
import { IResponse } from 'src/app/shared/interfaces/utils.interface';

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private store: Store<{ user: IUserFeatureState }>,
    private userService: UserService
  ) {}

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initUser),
      switchMap(() => {
        const storedProfile = localStorage.getItem('profile');
        if (storedProfile) {
          const profile = JSON.parse(storedProfile);
          return of(setUserInfo({ user: profile }));
        }
        return of(setUserInfo({ user: null }));
      })
    )
  );

  storedProfile$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setUserIsInitMerchant, setUserInfo, authenticatedProfileReady),
        withLatestFrom(this.store.select(selectUser)),
        tap(([action, profile]) => {
          if (profile) {
            localStorage.setItem('profile', JSON.stringify(profile));
          } else {
            localStorage.removeItem('profile');
          }
        })
      ),
    { dispatch: false }
  );

  fetchUserImage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateToken),
        withLatestFrom(this.store.select(selectUser)),
        switchMap(([action, profile]) => {
          if (!profile) {
            return EMPTY;
          }
          return this.userService.initMerchant().pipe(
            map((res: IResponse) => {
              return setUserInfo({
                user: {
                  ...profile,
                  image: res.data.image,
                },
              });
            })
          );
        })
      ),
    { dispatch: false }
  );
}
